import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';

export const MAIL_SPACE_MODAL_ID = 'mail-space-family-space-to-each-modal';
export const spaceToEachModalEnable = isFeature('space-to-each-modal-enable');
export const spaceToEachModalShowIntervalLimit = getFeature('space-to-each-modal-show-interval-limit') || 86400;

export const isFeatureSpaceToEachQuotaLandingPromo = isFeature(`3promo-enable-${MAIL_SPACE_MODAL_ID}`);

export const familySpaceExpValue: 'a' | 'b' = getFeature('family-space-exp-value');
export const isFamilySpaceExpValue = familySpaceExpValue === 'a';
